import { Component } from "react";
import React from "react";
import "./Service.css";
import {
  Box,
  Typography,
  Container,
  TextField,
  FormControl,
  MenuItem,
  InputLabel,
  Select,
  Button,
} from "@mui/material";
import Wsp from '../../contact/Component/Floatingwsp';
import { hasSubmittedToday, markSubmittedToday, DUPLICATE_LEAD_MESSAGE } from '../../../Common/leadDedupe';

class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      mobile: "",
      model: "",
      carRegisterationNumber: "",
      prefferedServiceCenterLocation: "",
      preferredDateforService: "",
      submitting: false,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.submitting) return;
    const {
      name, email, mobile, model,
      carRegisterationNumber,
      prefferedServiceCenterLocation,
      preferredDateforService,
    } = this.state;
    if (hasSubmittedToday(mobile)) {
      alert(DUPLICATE_LEAD_MESSAGE);
      return;
    }
    this.setState({ submitting: true });
    this.props.AddServiceForm(
      name, email, mobile, model,
      carRegisterationNumber,
      prefferedServiceCenterLocation,
      preferredDateforService
    );
    markSubmittedToday(mobile);
    this.setState({
      name: "", email: "", mobile: "", model: "",
      carRegisterationNumber: "",
      prefferedServiceCenterLocation: "",
      preferredDateforService: "",
    });
    setTimeout(() => this.setState({ submitting: false }), 3500);
  };

  render() {
    const {
      name, email, mobile, model,
      carRegisterationNumber,
      prefferedServiceCenterLocation,
      preferredDateforService,
      submitting,
    } = this.state;

    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const minDateTime = tomorrow.toISOString().slice(0, 16);

    return (
      <div id="service-page" style={{ overflowX: "hidden" }}>

        {/* ── BANNER ── */}
        <div id="banner-image-service">
          <div className="banner-overlay" />
          <div className="banner-content">
            <span className="banner-eyebrow">Authentic Care</span>
            <h1 className="banner-title">Precision In<br />Every Detail</h1>
            <p className="banner-sub">
              Our state-of-the-art service ecosystem is designed to maintain
              the peak performance of your Kia through elite engineering
              and certified expertise.
            </p>
            <a href="#service-form" className="banner-btn">
              Book Service <span className="btn-arrow">→</span>
            </a>
          </div>

          {/* Stats grid */}
          <div className="banner-stats">
            {[
              { num: "50+", label: "Elite Technicians" },
              { num: "10K+", label: "Cars Entrusted" },
              { num: "24/7", label: "Support Hub" },
              { num: "100%", label: "Original DNA" },
            ].map((s) => (
              <div className="stat-card" key={s.label}>
                <span className="stat-num">{s.num}</span>
                <span className="stat-label">{s.label}</span>
              </div>
            ))}
          </div>
        </div>

        <Wsp />

        {/* ── HOW IT WORKS ── */}
        <section className="how-section">
          <div className="section-tag">Service Excellence</div>
          <h2 className="section-title">How to Book Your Service</h2>
          <p className="section-sub">Three simple steps to premium care.</p>
          <div className="steps-row">
            {[
              { n: "01", title: "Fill Out the Form", desc: "Complete our simple online booking form with your contact information, vehicle details, and service needs." },
              { n: "02", title: "Select Date & Time", desc: "Choose a convenient date and time for your appointment from our available slots." },
              { n: "03", title: "Confirmation", desc: "Receive a confirmation call from us with all the details of your service appointment." },
            ].map((s) => (
              <div className="step-card" key={s.n}>
                <span className="step-num">{s.n}</span>
                <h3 className="step-title">{s.title}</h3>
                <p className="step-desc">{s.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── ADVANTAGES ── */}
        <section className="advantage-section">
          <div className="section-tag">The Advantage</div>
          <h2 className="section-title">Precision Meets Hospitality</h2>
          <div className="adv-grid">
            {[
              { icon: "⊙", tag: "CERTIFIED MASTERY", title: "Certified Mastery", desc: "Elite factory-trained technicians with a radical commitment to automotive perfection." },
              { icon: "⚙", tag: "ORIGINAL DNA", title: "Original DNA", desc: "Exclusive use of authenticated Kia components for uncompromising performance legacy." },
              { icon: "◎", tag: "RADICAL ASSURANCE", title: "Radical Assurance", desc: "Comprehensive warranty architecture covering every technical intervention performed." },
              { icon: "⊘", tag: "FLUID EFFICIENCY", title: "Fluid Efficiency", desc: "Optimized service protocols designed to respect and restore your most valuable asset: time." },
              { icon: "◈", tag: "QUALITY ARCHITECTURE", title: "Quality Architecture", desc: "Multistage quality synchronizations executed before any vehicle is returned to your care." },
              { icon: "☎", tag: "CONTINUOUS DIALOGUE", title: "Continuous Dialogue", desc: "24/7 concierge-level support hub for emergencies and technical advisory." },
            ].map((a) => (
              <div className="adv-card" key={a.tag}>
                <span className="adv-icon">{a.icon}</span>
                <span className="adv-tag">{a.tag}</span>
                <h3 className="adv-title">{a.title}</h3>
                <p className="adv-desc">{a.desc}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── EMERGENCY BAND ── */}
        <section className="emergency-band">
          <div className="emg-left">
            <span className="section-tag light">Concierge Assistance</span>
            <h2 className="emg-title">Need Emergency Intervention?</h2>
            <p className="emg-sub">Our elite roadside recovery units operate 24/7 across the region, providing radical support when it matters most.</p>
          </div>
          <a href="tel:+919090388999" className="emg-btn">📞 +91 9237301652</a>
        </section>

        {/* ── FORM SECTION ── */}
        <section className="form-section" id="service-form">
          <div className="form-left">
            <span className="section-tag">Precision Maintenance</span>
            <h2 className="form-left-title">Care For Your Vehicle</h2>
            <p className="form-left-desc">
              Entrust your vehicle to the experts. Our certified technicians use only genuine parts to ensure your Kia remains in peak condition.
            </p>
            <ul className="form-features">
              {[
                { icon: "◎", title: "Elite Technicians", desc: "Masters of Kia engineering with advanced certification." },
                { icon: "⚡", title: "Rapid Response", desc: "Streamlined diagnostics and service for minimal downtime." },
                { icon: "✦", title: "Authentic Parts", desc: "100% genuine Kia components with comprehensive warranty." },
              ].map((f) => (
                <li key={f.title} className="form-feature-item">
                  <span className="form-feature-icon">{f.icon}</span>
                  <div>
                    <strong>{f.title}</strong>
                    <p>{f.desc}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          {/* FORM */}
          <div className="form-card">
            <h3 className="form-card-title">Schedule Service</h3>
            <form onSubmit={this.handleSubmit}>
              <div className="form-row">
                <TextField
                  fullWidth required label="Name" type="text" variant="standard"
                  value={name}
                  onChange={(e) => this.setState({ name: e.target.value })}
                  placeholder="e.g. John Doe"
                  InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#d32f2f" } } }}
                  sx={fieldSx}
                />
                <TextField
                  fullWidth required label="Phone" type="number" variant="standard"
                  value={mobile}
                  onChange={(e) => this.setState({ mobile: e.target.value })}
                  placeholder="e.g. 9876543210"
                  InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#d32f2f" } } }}
                  sx={fieldSx}
                />
              </div>

              <div className="form-row">
                <FormControl fullWidth required variant="standard" sx={fieldSx}>
                  <InputLabel sx={{ "& .MuiInputLabel-asterisk": { color: "#d32f2f" } }}>Car Model</InputLabel>
                  <Select value={model} onChange={(e) => this.setState({ model: e.target.value })}>
                    {["Seltos","Sonet","Carens","EV6","Carnival","EV9","Syros","Syros EV","Sorento"].map(m => (
                      <MenuItem key={m} value={m.toLowerCase()}>{m}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  fullWidth required label="Registration No." type="text" variant="standard"
                  value={carRegisterationNumber}
                  onChange={(e) => this.setState({ carRegisterationNumber: e.target.value })}
                  placeholder="OD-39-ZZ-5697"
                  InputLabelProps={{ sx: { "& .MuiInputLabel-asterisk": { color: "#d32f2f" } } }}
                  sx={fieldSx}
                />
              </div>

              <div className="form-row">
                <FormControl fullWidth required variant="standard" sx={fieldSx}>
                  <InputLabel sx={{ "& .MuiInputLabel-asterisk": { color: "#d32f2f" } }}>Service Center</InputLabel>
                  <Select value={prefferedServiceCenterLocation} onChange={(e) => this.setState({ prefferedServiceCenterLocation: e.target.value })}>
                    {["Bhubaneswar","Sambalpur","Angul"].map(l => (
                      <MenuItem key={l} value={l}>{l}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <TextField
                  fullWidth required label="Preferred Date & Time" type="datetime-local" variant="standard"
                  value={preferredDateforService}
                  onChange={(e) => this.setState({ preferredDateforService: e.target.value })}
                  InputLabelProps={{ shrink: true, sx: { "& .MuiInputLabel-asterisk": { color: "red" } } }}
                  inputProps={{ min: minDateTime }}
                  sx={fieldSx}
                />
              </div>

              <TextField
                fullWidth label="Email (Optional)" type="email" variant="standard"
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                sx={{ ...fieldSx, mb: 3 }}
              />

              <button type="submit" className="form-submit-btn" disabled={submitting}>
                {submitting ? "Booking..." : "Book Appointment →"}
              </button>
              <p className="form-direct">Direct Contact: <a href="tel:+919090388999">+91 9237301652</a></p>
            </form>
          </div>
        </section>

      </div>
    );
  }
}

const fieldSx = {
  "& .MuiInput-underline:after": { borderBottomColor: "#111" },
  "& label.Mui-focused": { color: "#111" },
};

export default Contact;